/**
 * A global namespace for `touchcancel` event.
 */
const touchcancelEvent = "touchcancel";
export default touchcancelEvent;
